export const ParamGroups = {
    GENERAL: "GENERAL",
    REPRODUCTION: "REPRODUCTION",
    FARROWING: "FARROWING",
    SEPARATION: "SEPARATION",
    FINISHER: "FINISHER",
    WEANER: "WEANER",
    GILTS: "GILTS"
};